// extracted by mini-css-extract-plugin
export var barContainer = "_2j-0";
export var extraThin = "_2j-3";
export var fillBar = "_2j-6";
export var fillContainer = "_2j-4";
export var overflow = "_2j-8";
export var overflowContainer = "_2j-5";
export var regular = "_2j-7";
export var thick = "_2j-1";
export var thin = "_2j-2";